<template>
  <b-card :class="$route.path.includes('dashboard') ? 'h-100' : ''">
    <b-card-header class="p-0 pb-2">
      <b-card-title>
        <h4>آخرین جریمه ها</h4>
      </b-card-title>

      <div v-if="$route.path.includes('dashboard')">
        <span class="mr-1"> تعداد جریمه های پرداخت نشده</span>
        <b-skeleton
          v-if="loading"
          class="mb-0 d-inline-block"
          width="50px"
        ></b-skeleton>

        <b-badge variant="warning" v-else>{{ penaltiesCount }}</b-badge>
      </div>
    </b-card-header>
    <div class="d-flex flex-wrap" v-if="$route.path.includes('dashboard')">
      <b-form-group
        label="فیلتر بر اساس"
        class="mb-1 col-12 col-md-4 pr-md-2 px-0"
      >
        <select-box
          v-model="auditable_type"
          label="text"
          class="w-100"
          select="val"
          :lists="types"
          searchable
        />
      </b-form-group>
      <b-form-group
        v-if="auditable_type"
        class="mb-1 col-md-8 col-12 pr-md-2 px-0"
        label="انتخاب شناسه"
      >
        <select-box
          v-model="auditable_id"
          label="text"
          class="w-100"
          select="id"
          :url="auditable_type"
          searchable
        />
      </b-form-group>
    </div>

    <data-table :fields="fields" :items="penalties" :loading="loading">
      <template #selectuser="{ data }">
        <b-form-checkbox
          v-if="data.item.status == 0"
          v-model="penaltiesData"
          :value="data.item.id"
        ></b-form-checkbox>
      </template>
      <template #user="{ data }">
        <span style="white-space: nowrap">
          {{ data.item.user.first_name + " " + data.item.user.last_name }}
        </span>
      </template>
      <template #created_at="{ data }">
        {{ calcDate(data.item.created_at) || "-" }}
      </template>
      <template #payed_at="{ data }">
        {{ calcDate(data.item.payed_at) || "-" }}
      </template>
      <template #amount="{ data }">
        <span class="text-success"
          >{{ numberWithCommas(data.item.amount) }} تومان</span
        >
      </template>
      <template #rebate="{ data }">
        <span class="text-danger"
          >{{ numberWithCommas(data.item.rebate) }} تومان
        </span>
      </template>
      <template #detail="{ data }">
        <div>
          <div style="white-space: nowrap">
            دوره : {{ data.item.course.name }}
          </div>
          <div style="white-space: nowrap" class="my-50">
            جلسه : {{ data.item.session.name }}
          </div>
          <div style="white-space: nowrap">
            تمرین : {{ data.item.exercise.title }}
          </div>
        </div>
      </template>
      <template #status="{ data }">
        <b-badge
          :variant="
            data.item.status == 0
              ? 'info'
              : data.item.status == 1
              ? 'success'
              : 'warning'
          "
          >{{
            data.item.status == 0
              ? "در انتظار پرداخت"
              : data.item.status == 1
              ? "پرداخت شده"
              : "بخشیده شده"
          }}
        </b-badge>
      </template>
      <template #actions="{ data }">
        <!-- <b-button
          size="sm"
          v-if="data.item.status == 0"
          variant="flat-success"
          @click="checkout(data.item)"
          >پرداخت</b-button
        > -->
        <b-button
          size="sm"
          v-if="data.item.status == 0"
          variant="flat-info"
          @click="forgive(data.item)"
          >بخشش</b-button
        >
        <b-button
          size="sm"
          variant="flat-warning"
          @click="
            penalty = data.item;
            visible = true;
            rebate = '';
          "
          v-if="data.item.status == 0"
          >تخفیف</b-button
        >
      </template>
    </data-table>

    <div
      class="w-100 d-flex flex-wrap justify-content-between align-items-center"
    >
      <div
        class="col-md-12 d-flex justify-content-md-center align-items-center"
      >
        <b-pagination
          v-model="currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.per_page"
          size="md"
          class="mt-1 mb-0 d-flex justify-content-center"
        ></b-pagination>
      </div>
    </div>
    <b-modal v-model="visible" hide-footer size="sm" centered>
      <validation-observer ref="courseForm" #default="{ invalid }">
        <b-form @submit.prevent="makeRebate">
          <b-form-group label=" تخفیف (تومان)" label-for="rebate" class="my-1">
            <validation-provider
              #default="{ errors }"
              name="rebate"
              vid="rebate"
              rules="required"
            >
              <b-form-input
                autocomplete="on"
                id="rebate"
                v-model="rebate"
                class="mb-1"
                type="number"
                min="0"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-button
            variant="primary"
            class="mb-75"
            block
            type="submit"
            :disabled="invalid"
          >
            اعمال تخفیف
          </b-button>
        </b-form>
      </validation-observer>
    </b-modal>
    <loader :loading="loader" />
  </b-card>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BBadge,
  BPagination,
  BLink,
  BCard,
  BAvatar,
  BFormCheckbox,
  BForm,
  BFormInput,
  BFormGroup,
  BCardHeader,
  BCardTitle,
  BSkeleton,
} from "bootstrap-vue";
import DataTable from "@/@core/components/data-table/DataTable.vue";
import SelectBox from "@core/components/select-box/SelectBox.vue";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Loader from "@core/components/loader/Loader.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import qs from "qs";

export default {
  components: {
    DataTable,
    BButton,
    BCard,
    VBModal,
    BBadge,
    BPagination,
    BLink,
    BAvatar,
    BFormCheckbox,
    BModal,
    BForm,
    BFormInput,
    Loader,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BCardHeader,
    BCardTitle,
    BSkeleton,
    SelectBox,
  },
  directives: {
    "b-modal": VBModal,
  },
  props: {
    penaltiesCount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      choosenPage: 1,
      required,
      penalties: [],
      search: "",
      loading: false,
      selectAll: false,
      penaltiesData: [],
      url: "/panel/penalties",
      currentPage: 1,
      pagination: {},
      visible: false,
      loader: false,
      penalty: {},
      rebate: "",
      fields: [
        { key: "user", label: "نام کاربر" },
        { key: "created_at", label: "تاریخ جریمه" },
        { key: "amount", label: "مبلغ جریمه" },
        //   { key: "detail", label: "شرح" },
        { key: "status", label: "وضعیت" },
      ],
      types: [
        {
          id: 1,
          text: "ترم",
          val: "semester",
        },
        {
          id: 2,
          text: "دوره",
          val: "course",
        },
      ],

      auditable_type: "",
      auditable_id: "",
    };
  },

  watch: {
    currentPage(val) {
      this.getPenalties(val);
    },
    auditable_type(val) {
      this.auditable_id = "";
    },
    auditable_id(val) {
      if (this.auditable_type == null) {
        this.getPenalties();
      }
      if (this.auditable_type && val) {
        this.getPenalties();
      }
    },
  },
  async created() {
    this.getPenalties();
  },

  methods: {
    async getPenalties(page) {
      this.loading = true;
      try {
        let filters = {};
        if (this.$route.path.includes("dashboard")) {
          this.auditable_type &&
            this.auditable_id &&
            (filters[`${this.auditable_type}_id`] = this.auditable_id);
        } else if (this.$route.path.includes("users")) {
          filters = {
            user_id: this.$route.params.id,
          };
        }

        const { data } = await this.$http.get(this.url, {
          params: {
            includes: ["transactions", "exercise", "user", "course", "session"],
            per_page: 8,
            page: page || 1,
            filters: {
              ...filters,
            },
          },
          paramsSerializer: (params) => {
            return qs.stringify(params);
          },
        });
        this.penalties = data.data.penalties;
        this.pagination = data.data.meta.pagination;
        this.currentPage = await this.pagination.current_page;
      } catch (err) {}
      this.loading = false;
    },
  },
};
</script>
